<template>
    <div class="container">
        <h2 class="text-center mt-2" style="color:white;">{{ total_result }}   Result for   "{{ $route.query.query }}"</h2>
        <div class="card card-sm my-3">
            <div class="card-body row no-gutters align-items-center">
            <div class="col-auto">
                <i class="icon-magnifying-glass h4 text-body"></i>
            </div>
            <!--end of col-->
            <div class="col">
                <input class="form-control form-control-lg form-control-borderless" type="search" placeholder="Search topics or keywords" v-model="search_string" @keypress.enter="search" />
            </div>
            <!--end of col-->
            <div class="col-auto">
                <button :class="'btn btn-lg btn-success'" @click="search">Search</button>
            </div>
            <!--end of col-->
            </div>
        </div>
        <hr>
        <ul v-if="!loading_rm ">
            <li v-for="(result, i) in search_results" :key="i" >
                <router-link :to="'/detail?common_number='+result.common_number">{{result.particular}}</router-link>
                <p>{{result.description}}</p>
                <small>{{result.date_uploaded}}</small>
            </li>
            <li class="d-flex justify-content-center" v-if="total > page">
                    <button class="loadMore" @click="loadMore()" v-if="pageload==false">Load More..</button>
                    
            </li>
             <li class="d-flex justify-content-center" v-if="!total_result">
             
                <h1 class="text-center">No result for "{{ $route.query.query  }}"</h1>
                    
            </li>
            
            <li class="d-flex justify-content-center" v-if="pageload">
                <button class="loadMore" > <span class="spinner-border"></span> loading...</button>
            </li>
        </ul>
        <ul v-else>
            <li style="text-align: center;">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </li> 
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            query_string: '',
            search_string: '',
            search_results: [],
            loading_rm : false,
            page: 1,
            total: 1,
            pageload: false,
            total_result: ''
            
        }
    },
    methods: {
        async searchData() {
            var query = this.$route.query.query;
            await this.$axios.get(`/search?query=${query}&page=${this.page}`)
                    .then(res => {

                        if(this.page > 1){

               
                            res.data.result.forEach(element => {
                                this.search_results.push(element)

                            });


                        }
                        else{
                            this.search_results = res.data.result;
                        }
                        this.total = res.data.total_page
                        this.total_result = res.data.total
                        this.pageload = false
                        this.loading_rm = false;

                                    //  console.log(res.data)
                                    //  console.log(this.total)
                        
                    })
                    .catch(err => {
                        console.error(err);
                        this.loading_rm = false;
                        
                    })
        },
        search() {
            if(this.search_string == '') return;
            
            this.page = 1
            this.loading_rm = true,

            
            this.$router.push(`/result?query=${this.search_string}&page=${this.page}`)
            setTimeout(() => {
                this.searchData();
            }, 200);
        },
        loadMore(){
            this.pageload = true
            this.page ++
            this.searchData()
   
        }
        
    },
    mounted() {
        if(this.$route.query.query === '') return this.$router.push('/searcher');
        this.loading_rm = true;
        this.search_string = this.$route.query.query
        this.searchData();
        // {
        //     query: 'loan',
        //     page: 1
        // }
    }
}
</script>

<style scoped>
img{
        filter: blur(1px);
        -webkit-filter: blur(1px);
}
.container{
    overflow:auto;
    height: 100%;
  
   
}
/* width */
::-webkit-scrollbar {
  width: 15px;

}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: lightgrey; 
  border-radius: 10px;

}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey; 
}
ul {
    list-style-type: none;
    padding-left: 0;
}

ul li {
    margin-bottom: 18px;
}

ul li a {
    font-size: 20px;
    font-weight: 500;
}

ul li p {
    margin-bottom: 0;
}

.loadMore{
    font-size: 20px;
    font-weight: 500;
    color: white;
    border: none;

    background: rgba(225,225,225,0);

}

a,p,small{
    color: white;
}
</style>